import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import AppLayout from "../Layout/AppLayout";
// Pages Route Import
import Login from "../Pages/Auth/Login";
import EnquiriesRequests from "../Pages/EnquiriesRequests";
import ViewEnquiriesRequests from "../Pages/EnquiriesRequests/ViewEnquiriesRequests";
import SystemSettings from "../Pages/SystemSettings";
import VendorPayouts from "../Pages/VendorPayouts";
import VendorPayoutsDetail from "../Pages/VendorPayouts/VendorPayoutsDetail";
import DriverPayouts from "../Pages/DriverPayouts";
import DriverPayoutsDetail from "../Pages/DriverPayouts/DriverPayoutsDetail";
import ManageQC from "../Pages/ManageQC";
import AddNewQC from "../Pages/ManageQC/AddNewQC";
import ManageVendor from "../Pages/ManageVendor";
import AddVendor from "../Pages/ManageVendor/AddVendor";
import ManageDriver from "../Pages/ManageDriver";
import ViewDriver from "../Pages/ManageDriver/ViewDriver";
import AddNewDriver from "../Pages/ManageDriver/AddNewDriver";
import ManageSubAdmin from "../Pages/ManageSubAdmin";
import CreateRole from "../Pages/RolesPermissions/CreateRole";
import CreateSubAdmin from "../Pages/ManageSubAdmin/CreateSubAdmin";
import SubAdminDetails from "../Pages/ManageSubAdmin/SubAdminDetails";
import RolesPermissions from "../Pages/RolesPermissions";
import AddBranch from "../Components/VendorInformation/VendorInformationTabs/BranchesDetails/AddBranch";
import ManageBusinessCategories from "../Pages/ManageBusinessCategories";
import ManageItemSensitivity from "../Pages/ManageItemSensitivity";
import ManageZones from "../Pages/ManageZones";
import AddZone from "../Pages/ManageZones/AddZone";
import TimeslotsHolidays from "../Pages/ManageZones/TimeslotsHolidays";
import ManageVehicleType from "../Pages/ManageVehicleType";
import AddVehicleType from "../Pages/ManageVehicleType/AddVehicleType";
import ManagePackagingType from "../Pages/ManagePackagingType";
import AddPackagingType from "../Pages/ManagePackagingType/AddPackagingType";
import ManageDropZone from "../Pages/ManageDropZone";
import AddDropZone from "../Pages/ManageDropZone/AddDropZone";
// import TimeslotsHolidays from "../Pages/TimeslotsHolidays";
import EditHours from "../Pages/TimeslotsHolidays/EditHours";
import EditDropzonesHours from "../Pages/TimeslotsHolidays/EditDropZoneHours";
import EditBranchHours from "../Pages/TimeslotsHolidays/EditBranchHours";
import ReturnPolicy from "../Pages/CMS/ReturnPolicy";
import PrivacyPolicy from "../Pages/CMS/PrivacyPolicy";
import TermsConditions from "../Pages/CMS/TermsConditions";
import VendorEnquiresList from "../Pages/CMS/VendorEnquiresList";
import OrderManagement from "../Pages/OrderManagement";
import PageNotFound from "../Pages/PageNotFound";
import EditSlot from "../Components/VendorInformation/VendorInformationTabs/BranchesDetails/AddBranch/AddbranchTab/BranchTimeSlot/EditSlot";
import ForgotPassword from "../Pages/Auth/ForgetPassword";
import ResetPassword from "../Pages/Auth/ResetPassword";
import { ProtectedLoginRouter, ProtectedRouter } from "../utils/global/protectedRouter";
import ManageModifiers from "../Pages/ManageModifiers";
import AddModifier from "../Pages/ManageModifiers/AddModifier";
import DropZoneSlot from "../Pages/ManageDropZone/DropZoneSlot";
import ProductManagement from "../Pages/ProductManagement";
import AddProduct from "../Pages/ProductManagement/AddProduct";
import EditOrder from "../Pages/OrderManagement/EditOrder";
import SubmitOrderQC from "../Pages/OrderManagement/SubmitOrderQC";
import Report from "../Pages/Report";
import ManageCoupon from "../Pages/ManageCoupon";
import CreateCoupon from "../Pages/ManageCoupon/CreateCoupon";
import ZoneOrder from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByZone/ZoneOrder/page";
import ItemOrder from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByItem/ItemOrder/page";
import CustomerOrder from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByCustomer/CustomerOrder/page";
import OrderType from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByOrderType/OrderType/page";
import OrderDeliveryMode from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByDeliveryMode/OrderDeliveryMode/page";
import OrderTimeSlot from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByTimeSlot/OrderTimeSlot/page";
import ManageSubscriptions from "../Pages/ManageSubscriptions";
import AddSubscription from "../Pages/ManageSubscriptions/AddSubscription";
import VendorDataReport from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByVendor/VendorOrder/page";
import DriverDataReport from "../Pages/Report/ReportTabs/SalesReports/SalesReportsTabs/SalesByDriver/DriverOrders/page";
import Wallet from "../Components/VendorInformation/VendorInformationTabs/Wallet";
import WalletHistory from "../Components/VendorInformation/VendorInformationTabs/WalletHistory";
// import AddProduct from "../Pages/ProductManagement/AddProduct";
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* auth Route */}
      <Route element={<ProtectedRouter />}>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<ResetPassword />} />
      </Route>
      {/* AppLayout with Sidebar and Header */}
      <Route path="/" element={<AppLayout />}>
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* New Pages Routing */}
        <Route element={<ProtectedLoginRouter />}>
          <Route path="/manage-QC" element={<ManageQC />} />
          <Route path="/add-new-QC" element={<AddNewQC />} />
          <Route path="/edit-QC/:id" element={<AddNewQC />} />
          <Route path="/manage-vendor" element={<ManageVendor />} />
          <Route path="/add-vendor" element={<AddVendor />} />
          <Route path="/edit-vendor/:id" element={<AddVendor />} />
          <Route path="/add-branch/:id" element={<AddBranch />} />
          <Route path="/edit-branch/:id/:branchId" element={<AddBranch />} />
          <Route path="/edit-slot/:id/:branchId" element={<EditSlot />} />
          <Route path="/manage-driver" element={<ManageDriver />} />
          <Route path="/add-new-driver" element={<AddNewDriver />} />
          <Route path="/edit-driver/:id" element={<AddNewDriver />} />
          <Route path="/view-driver/:id" element={<ViewDriver />} />
          <Route path="/manage-sub-admin" element={<ManageSubAdmin />} />
          <Route path="/create-sub-admin" element={<CreateSubAdmin />} />
          <Route path="/edit-sub-admin/:id" element={<CreateSubAdmin />} />
          <Route path="/sub-admin-details" element={<SubAdminDetails />} />
          <Route path="/edit-hours" element={<EditHours />} />
          <Route path="/roles-permissions" element={<RolesPermissions />} />
          <Route path="/roles-permissions/create-role" element={<CreateRole />} />
          <Route path="/roles-permissions/edit-role/:id" element={<CreateRole />} />
          <Route path="/manage-business-categories" element={<ManageBusinessCategories />} />
          <Route path="/manage-coupon" element={<ManageCoupon />} />
          <Route path="/manage-coupon/create-coupon" element={<CreateCoupon />} />
          <Route path="/manage-coupon/edit-coupon/:id" element={<CreateCoupon />} />
          <Route path="/manage-zones" element={<ManageZones />} />
          <Route path="/add-zone" element={<AddZone />} />
          <Route path="/edit-zone/:id" element={<AddZone />} />
          <Route path="/zone/timeslots-holidays/:id" element={<TimeslotsHolidays />} />
          <Route path="/zone/timeslots-holidays/edit-hours/:id" element={<EditHours />} />
          <Route path="/dropzone/timeslots-holidays/edit-hours/:id" element={<EditDropzonesHours />} />
          <Route path="/branch/timeslots-holidays/edit-hours/:id/:branchId" element={<EditBranchHours />} />
          <Route path="/manage-vehicle-type" element={<ManageVehicleType />} />
          <Route path="/add-vehicle-type" element={<AddVehicleType />} />
          <Route path="/edit-vehicle-type/:id" element={<AddVehicleType />} />
          <Route path="/manage-packaging-type" element={<ManagePackagingType />} />
          <Route path="/add-packaging-type" element={<AddPackagingType />} />
          <Route path="/edit-packaging-type/:id" element={<AddPackagingType />} />
          <Route path="/manage-drop-zone" element={<ManageDropZone />} />
          <Route path="/add-drop-zone" element={<AddDropZone />} />
          <Route path="/edit-drop-zone/:id" element={<AddDropZone />} />
          <Route path="/edit-dropzone-slot/:id" element={<DropZoneSlot />} />
          <Route path="/manage-item-sensitivity" element={<ManageItemSensitivity />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/vendor-enquires-list" element={<VendorEnquiresList />} />
          <Route path="/enquiries-requests" element={<EnquiriesRequests />} />
          <Route path="/view-enquiries-requests" element={<ViewEnquiriesRequests />} />
          <Route path="/system-settings" element={<SystemSettings />} />
          <Route path="/vendor-payouts" element={<VendorPayouts />} />
          <Route path="/vendor-payouts-detail/:id" element={<VendorPayoutsDetail />} />
          <Route path="/driver-payouts" element={<DriverPayouts />} />
          <Route path="/driver-payouts-detail/:id" element={<DriverPayoutsDetail />} />
          <Route path="/order-management" element={<OrderManagement />} />
          <Route path="/edit-order/:id" element={<EditOrder />} />
          <Route path="/manage-modifiers" element={<ManageModifiers />} />
          <Route path="/add-modifiers" element={<AddModifier />} />
          <Route path="/edit-modifiers/:id" element={<AddModifier />} />
          <Route path="/product-management" element={<ProductManagement />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/edit-product/:id" element={<AddProduct />} />
          <Route path="/edit-order" element={<EditOrder />} />
          <Route path="/submit-order-qc/:id" element={<SubmitOrderQC />} />
          <Route path="/report" element={<Report />} />
          <Route path="/zone-order/:id" element={<ZoneOrder />} />
          <Route path="/item-order/:id" element={<ItemOrder />} />
          <Route path="/customer-order/:id" element={<CustomerOrder />} />
          <Route path="/get-order-type/:orderType?" element={<OrderType />} />
          <Route path="/get-vendor-orders/:vendorId?" element={<VendorDataReport />} />
          <Route path="/get-driver-orders/:driverId?" element={<DriverDataReport />} />
          <Route path="/get-delivery-mode/:deliveryMode?" element={<OrderDeliveryMode />} />
          <Route path="/get-time-slot/:id" element={<OrderTimeSlot />} />
          <Route path="/manage-subscription" element={<ManageSubscriptions />} />
          <Route path="/add-subscription" element={<AddSubscription />} />
          <Route path="/edit-subscription/:id" element={<AddSubscription />} />
          <Route path="/vendor-wallet/:id" element={<Wallet />} />
          <Route path="/vendor-wallet-history/:id" element={<WalletHistory />} />
        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
);
const Routings = () => {
  return <RouterProvider router={router} />;
};
export default Routings;
